import { COURSE_DELETE_RETENTION_HOURS } from "../../utils/variables";

export enum CourseListingMode {
  PUBLISHED = 'published',
  DRAFTS = 'drafts',
  TRASH = 'trash',
}

export const CourseListingModeTextRecord: Record<CourseListingMode, string> = {
  [CourseListingMode.PUBLISHED]: 'Cursos',
  [CourseListingMode.DRAFTS]: 'Rascunhos',
  [CourseListingMode.TRASH]: 'Cursos excluídos',
};

export const CourseListingModeDescriptionRecord: Record<CourseListingMode, string> = {
  [CourseListingMode.PUBLISHED]: 'Visualize e gerencie os cursos da plataforma',
  [CourseListingMode.DRAFTS]: `Os cursos serão excluídos permanentemente após ${COURSE_DELETE_RETENTION_HOURS} horas.`,
  [CourseListingMode.TRASH]: 'Visualize e gerencie os cursos excluídos',
};